@if (entry?.base?.display) {
  <div>
    <div [innerHTML]="safeHtml ? safeHtml : entry?.base?.text"></div>
    <div [ngClass]="{'ih-inline-config-display': !entry?.custom?.isFormStyle, 'ih-form-display': entry?.custom?.isFormStyle}">
      <div class='form-label' [innerHTML]="entry?.custom?.label"> </div>
      @for (val of value; track val) {
        <div>
          {{val}}
        </div>
      }
    </div>
  </div>
}